import { Ability, AbilityBuilder } from '@casl/ability';
import store from '../redux/store/index';
import * as resourcesList from '../constants/resources';

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }

  return item.__type;
}

const ability = new Ability([], { subjectName });

const methods = {
  GET: 'read',
  POST: 'create',
  PATCH: 'update',
  PUT: 'update',
  DELETE: 'delete',
};

// get resources from the constants file into an array
const obj = { ...resourcesList };
const resources = Object.keys(obj).map((key) => obj[key]);

function defineRulesFor(auth) {
  const { can, rules } = new AbilityBuilder();
  if (!auth) {
    return rules;
  }
  const { permissions } = auth.role;
  permissions.forEach((permission) => {
    if (resources.includes(permission.resource)) {
      can(methods[permission.method], permission.resource);
    }
  });
  return rules;
}

let currentAuth;
store.subscribe(() => {
  const prevAuth = currentAuth;
  currentAuth = store.getState().auth.authUser;
  if (prevAuth !== currentAuth) {
    ability.update(defineRulesFor(currentAuth));
  }
});

export default ability;
